import { createSlice } from "@reduxjs/toolkit";

/**
 * Auth slice — stores the short-lived access token in Redux memory only.
 *
 * WHY memory (not localStorage)?
 *   localStorage is readable by any JS running on the page (XSS).
 *   Keeping the token only in Redux memory means it never touches disk
 *   and is gone the moment the tab closes.  The httpOnly refresh-token
 *   cookie is what survives page reloads; the browser manages it and JS
 *   cannot read it.
 */
const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: null,
    maxSessionUntil: null, // absolute session expiry from the backend
  },
  reducers: {
    setCredentials: (state, action) => {
      state.token = action.payload.token;
      // Preserve existing maxSessionUntil on silent refresh (backend may omit it)
      if (action.payload.maxSessionUntil !== undefined) {
        state.maxSessionUntil = action.payload.maxSessionUntil;
      }
    },
    clearCredentials: (state) => {
      state.token = null;
      state.maxSessionUntil = null;
    },
  },
});

export const { setCredentials, clearCredentials } = authSlice.actions;
export default authSlice.reducer;

// Selectors
export const selectCurrentToken = (state) => state.auth.token;
export const selectMaxSessionUntil = (state) => state.auth.maxSessionUntil;
